import React, { FunctionComponent, useState } from 'react';
import { ITooltipProps } from './types';

export const Tooltip: FunctionComponent<ITooltipProps> = ({ content, direction, children, bgColor, textColor }) => {
  const [active, setActive] = useState(false);

  const showTip = () => {
    setActive(true);
  };

  const hideTip = () => {
    //clearInterval(timeout);
    setActive(false);
  };

  return (
    <div
      className="Tooltip-Wrapper"
      // When to show the tooltip
      onMouseEnter={showTip}
      onMouseLeave={hideTip}
    >
      {/* Wrapping */}
      {active && direction === 'top' && (
        <div
          className={`Tooltip-Tip ${direction || 'top'}`}
          style={{ backgroundColor: `${bgColor}`, color: `${textColor}`, bottom: '200%' }}
        >
          {/* Content */}
          {content}
        </div>
      )}
      {children}
      {active && direction !== 'top' && (
        <div
          className={`Tooltip-Tip ${direction || 'top'}`}
          style={{ backgroundColor: `${bgColor}`, color: `${textColor}` }}
        >
          {/* Content */}
          {content}
        </div>
      )}
    </div>
  );
};
